module.exports = __webpack_public_path__ + "img/ico_exames.c0982bc3.svg";